module.exports = __webpack_public_path__ + "static/media/galleryGT (17).7cc92c17.jpg";